import * as React from 'react';
import { PageSectionWrapper } from './PageSection_SC';
import { XISVG } from '@inmoment/the-kitchen';
import { VersionType } from './VersionType/VersionType';
import { BreakingChange } from '../../../../useBreakingChanges';

export interface VersionUpdates {
  fixed?: string[];
  added?: string[];
  [key: string]: string[] | undefined;
}
export interface Props {
  updateItem: BreakingChange;
  backgroundColor: string;
  isBreaking?: boolean;
}

export const PageSection: React.FC<Props> = (props) => {
  const {
    backgroundColor,
    updateItem: { version, date, added, removed, changed, fixed },
    isBreaking,
  } = props;

  const toBeMapped: JSX.Element[] = [];

  if (added.length > 0) {
    toBeMapped.push(<VersionType key="added" isBreaking={isBreaking} type={'Add'} list={added} />);
  }
  if (removed.length > 0) {
    toBeMapped.push(<VersionType key="removed" isBreaking={isBreaking} type={'Remove'} list={removed} />);
  }
  if (changed.length > 0) {
    toBeMapped.push(<VersionType key="changed" isBreaking={isBreaking} type={'Change'} list={changed} />);
  }
  if (fixed.length > 0) {
    toBeMapped.push(<VersionType key="fixed" isBreaking={isBreaking} type={'Fix'} list={fixed} />);
  }

  return (
    <PageSectionWrapper background={backgroundColor}>
      <div
        style={{
          width: '30%',
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <div>
          <p className="orca kxi-text-600">v{version}</p>
          <p className="orca ">{date}</p>
        </div>
        <div style={{ width: 54, height: 54 }}>
          <XISVG svg="inmoment_favicon_blue" />
        </div>
      </div>
      <div style={{ width: '70%', overflowY: 'auto' }}>{toBeMapped}</div>
    </PageSectionWrapper>
  );
};
